import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "@/router/router";
import store from "./store";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import "bootstrap";

import jquery from "jquery";
window.$ = jquery;

import api from "./api";
Vue.prototype.$api = api;

// Loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

// 圖表
import VueApexCharts from "vue-apexcharts";

// HTML編輯器 (範本維護)
import { VueEditor } from "vue2-editor";

// 捲軸
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

// element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-TW";
Vue.use(ElementUI,  { locale });
Vue.prototype.$notify = ElementUI.Notification;
Vue.prototype.$msgbox = ElementUI.MessageBox;

// vee-validate (驗證)
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
} from "vee-validate";

import {
  required,
  numeric,
  alpha_dash,
  alpha_num,
  alpha_spaces,
  min,
  min_value,
  max,
  max_value,
  is_not,
  excluded,
  email,
  confirmed,
  integer,
  regex,
} from "vee-validate/dist/rules";
import EN from "vee-validate/dist/locale/en.json";
import TW from "vee-validate/dist/locale/zh_TW.json";

// cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

// 日期
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-cn";

// day.js-------------------------------------------------------------------
import dayjs from "dayjs";
Vue.prototype.dayjs = dayjs;
// ---------------------------------------------------------------------------------

// Table
import VueBootstrap4Table from "vue-bootstrap4-table";

// Select (單選)
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

// Select (多選)
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

// Select (樹狀)
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

// 電子簽名板 (適性測驗 & 健康評估)
import VueSignature from "vue-signature";

// 拖拉
import draggable from "vuedraggable";

// 多國語系
import VueI18n from "vue-i18n";
import zh from "../public/i18n/zh.json";
import en from "../public/i18n/en.json";

// eva icon
import EvaIcons from "vue-eva-icons";

// input facade
import InputFacade from "vue-input-facade";

//el-transfer優化
import { krryPaging } from "krry-transfer";
Vue.use(krryPaging);

// fortawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@fortawesome/fontawesome-free/js/all";
library.add(faUserSecret, faEye, faEyeSlash);

///////////////////////////////////////////////////////////////////

import "./bus";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(EvaIcons);
Vue.use(PerfectScrollbar);
Vue.use(InputFacade);

Vue.component("Loading", Loading);
Vue.component("draggable", draggable);
Vue.component("VueEditor", VueEditor);
Vue.component("VueBootstrap4Table", VueBootstrap4Table);
Vue.component("apexchart", VueApexCharts);
Vue.component("DatePicker", DatePicker);
Vue.component("v-select", vSelect);
Vue.component("multiselect", Multiselect);
Vue.component("Treeselect", Treeselect);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("VueSignature", VueSignature);
Vue.component("font-awesome-icon", FontAwesomeIcon);

////// vee-validate (rule) ///////////////////////////////////////////////

localize("EN", EN);
localize("TW", TW);
extend("integer", integer);
extend("min", min);
extend("max", max);
extend("excluded", excluded);
extend("alpha_dash", alpha_dash);
extend("alpha_num", alpha_num);
extend("alpha_spaces", alpha_spaces);
extend("is_not", is_not);
extend("confirmed", confirmed);
extend("regex", regex);

extend("required", {
  ...required,
  message: (_, values) => i18n.t("vee-validations.Required", values),
});

extend("english_name", {
  ...alpha_spaces,
  message: (_, values) => i18n.t("vee-validations.English_Name", values),
});

extend("not_choose", {
  ...is_not,
  message: "{_field_} 不得選取在職中",
});

extend("email", {
  ...email,
  message: (_, values) => i18n.t("vee-validations.Email", values),
});

extend("numeric", {
  ...numeric,
  message: (_, values) => i18n.t("vee-validations.Numeric", values),
});

extend("dateRangeRequired", {
  validate: (value) => {
    let startDate = value[0];
    let endDate = value[1];
    return startDate instanceof Date && endDate instanceof Date;
  },
  message: (_, values) => i18n.t("vee-validations.Required", values),
});

extend("cellPhone", {
  validate: (value, args) => {
    return value.length == args.length;
  },
  params: ["length"],
  message: (_, values) => i18n.t("vee-validations.CellPhone", values),
});

extend("notLessThenSalaryLow", {
  params: ["min"],
  validate: (value, { min }) => {
    return value > min;
  },
  message: (_, values) =>
    i18n.t("vee-validations.Not_Less_Then_Salary_Low", values),
});

extend("notBeforeStartDate", {
  params: ["min"],
  validate: (value, { min }) => {
    return value > min;
  },
  message: (_, values) =>
    i18n.t("vee-validations.Not_Before_Start_Date", values),
});

extend("password_length", {
  validate: (value, args) => {
    return value.length >= args.length;
  },
  params: ["length"],
  message: "{_field_} 長度不符合",
});

extend("password_complexity", {
  validate: (value) => {
    return !!value && value.length >= 12 && /[a-z]/.test(value) && /[A-Z]/.test(value) && /\d/.test(value);
  },
  message: "{_field_} 須含大小寫英文及數字，至少12個字元",
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "新密碼輸入不符",
});

extend("min_value", {
  ...min_value,
  message: TW.messages.min_value,
  params: ["min"],
});

extend("checkbox", {
  validate: (value) => {
    return value !== false;
  },
  message: "請新增 {_field_}",
});

extend("department", {
  validate: (value, { department }) => {
    return department.length === 0;
  },
  message: "請新增 {_field_}2",
  params: ["department"],
});

extend("max_value", {
  ...max_value,
  message: TW.messages.max_value,
  params: ["max"],
});

extend("my_not", {
  validate: (value, { now }) => {
    return value !== now;
  },
  message: "{_field_} 不可重複",
  params: ["now"],
});

extend("demandApply_PositionValue", {
  // 職務名稱
  validate: (value) => {
    return value.PositionCode !== null;
  },
  message: "{_field_} 為必填",
});

////////////////// 多國語系 ///////////////////////////////////////
const language = localStorage.getItem("i18n-lang") || "zh-TW";

const i18n = new VueI18n({
  locale: language,
  messages: {
    "zh-TW": zh,
    "en-US": en,
  },
  silentTranslationWarn: true,
});

////////////////////////////////////////////////////////////////

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

//////////// axios 攔截器 /////////////////////////////////////////////////
axios.defaults.timeout = 300000;
axios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + VueCookies.get("AUTH_TOKEN");
    config.headers["Content-Type"] = "application/json; charset=utf-8";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//////////// API Response Status /////////////////////////////////////////////////

axios.interceptors.response.use(
  (config) => {
    if (config.headers.authorization) {
      VueCookies.set("AUTH_TOKEN", config.headers.authorization);
    }
    return config;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          store.dispatch("updateLoading", false);
          ElementUI.Notification({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
          break;
        case 401:
          store.dispatch("updateLoading", false);
          VueCookies.keys().forEach((cookie) => VueCookies.remove(cookie));
          if (localStorage.getItem("PLACE") === "/login") {
            router.push({ path: "/login" });
          } else if (localStorage.getItem("PLACE") === "/signIn") {
            router.push({ path: "/signIn" });
          } else {
            router.push({ path: "/" });
          }
          break;
        case 403:
          store.dispatch("updateLoading", false);
          ElementUI.Notification({
            title: "錯誤",
            message: "登入失敗。",
            type: "error",
            duration: 3500,
          });
          break;
        case 404:
          store.dispatch("updateLoading", false);
          ElementUI.Notification({
            title: "錯誤",
            message: "A 404 ERROR，請聯繫系統管理員。",
            type: "error",
            duration: 3500,
          });
          break;
        case 500:
          store.dispatch("updateLoading", false);
          ElementUI.Notification({
            title: "錯誤",
            message: "500 Internal Server Error，請聯繫系統管理員。",
            type: "error",
            duration: 3500,
          });
          break;

        default:
          console.error("沒有攔截到的錯誤:" + error);
      }
    } else {
      ElementUI.Notification({
        title: "錯誤",
        message: "系統程式發生錯誤，請聯繫系統管理員。",
        type: "error",
        duration: 3500,
      });
    }
    return Promise.reject(error);
  }
);


Vue.prototype.$Permission = JSON.parse(
  localStorage.getItem("userPermission")
); 
//////////// 路由 /////////////////////////////////////////////////

router.beforeEach((to, from, next) => {
  Vue.prototype.$Permission = JSON.parse(
    localStorage.getItem("userPermission")
  );  // 權限判斷，放在這邊就能確實在元件啟動時抓到，否則會抱錯。
  // 用來判斷是管理者登入還是應聘者登入
  if (from.matched[0].path === "/login" || from.matched[0].path === "/signIn") {
    localStorage.setItem("PLACE", from.matched[0].path);
  }
  if (to.matched.some((record) => record.meta.managerAuth)) {
    if (VueCookies.get("AUTH_TOKEN")) {
      localStorage.setItem("FROM_PAGE", from.name);
      next();
    } else {
      next({ path: "/login" });
    }
  } else if (to.matched.some((record) => record.meta.candidateAuth)) {
    if (VueCookies.get("AUTH_TOKEN")) {
      next();
    } else {
      next({ path: "/signIn" });
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

////////////////// 共用方法 ///////////////////////////////////////
import common from "@/assets/js/common";
Vue.prototype.$common = common;

import get_department from "@/assets/js/select/department.js";
Vue.use(get_department);

import get_position from "@/assets/js/select/position.js";
Vue.use(get_position);

import get_workplace from "@/assets/js/select/workplace.js";
Vue.use(get_workplace);

import get_education_degree from "@/assets/js/resume/education_degree.js";
Vue.use(get_education_degree);

import get_major_subject_category from "@/assets/js/resume/major_subject_category.js";
Vue.use(get_major_subject_category);

import get_working_hours from "@/assets/js/resume/working_hours.js";
Vue.use(get_working_hours);

import get_foreign_language from "@/assets/js/resume/foreign_language.js";
Vue.use(get_foreign_language);

import get_dialect from "@/assets/js/resume/dialect.js";
Vue.use(get_dialect);

import get_driver_license from "@/assets/js/resume/driver_license.js";
Vue.use(get_driver_license);

import get_recruitment_method from "@/assets/js/resume/recruitment_method.js";
Vue.use(get_recruitment_method);

import get_salary_type from "@/assets/js/resume/salary_type.js";
Vue.use(get_salary_type);

import get_language_degree from "@/assets/js/resume/language_degree.js";
Vue.use(get_language_degree);

import get_nationality from "@/assets/js/resume/nationality.js";
Vue.use(get_nationality);

import get_marital_status from "@/assets/js/resume/marital_status.js";
Vue.use(get_marital_status);
